<template>
    <div @mouseenter="showAction = true" @mouseleave="showAction = false">
        <el-form :model="oneForm" style="text-align: left" class="oneForm">
            <el-form-item :label="rank +'. ' + oneForm.title"> </el-form-item>
            <el-form-item>
                <el-input style="width: 300px;margin-bottom: 10px" v-show="oneForm.type === 'input'"></el-input>

                <el-radio-group v-model="radio" v-show="oneForm.type === 'radio'">
                    <el-radio v-for="(item, index) in oneForm.data" :key="index" :label="item">
                        {{item}}
                    </el-radio>
                </el-radio-group>
                <el-checkbox-group v-model="checkedData" v-show="oneForm.type === 'checkBox'">
                    <el-checkbox v-for="(item, index) in oneForm.data" :label="item" :key="item+index">{{item}}</el-checkbox>
                </el-checkbox-group>

            </el-form-item>
            <el-form-item style="width: 100%; " v-show="showAction">
                <el-button type="primary" plain @click.stop="()=> editOneForm()">编辑</el-button>
                <el-button type="danger" plain @click.stop="()=> delOneForm()">删除</el-button>
                <el-button type="success" plain @click.stop="()=> moveAction('up')">上移</el-button>
                <el-button type="warning" plain style=" margin-bottom: 10px" @click.stop="()=> moveAction('down')">下移</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    export default {
        props: ["row", "rank"],
        created() {
            this.initData()
        },
        computed: {
            getName: function () {
                return this.editOne.uuid
            }
        },
        watch: {
            getName: {
                handler(newV) {
                    //do something
                    if (newV == this.row.uuid) {
                        this.editOne = newV
                        // this.initData()
                    }
                }
            }
        },
        data() {
            return {
                showAction: false,
                oneForm: {},
                radio: "",
                checkedData: [],
                editOne: ""
            }
        },
        methods: {
            initData() {
                if (this.row) {
                    let data = JSON.parse(JSON.stringify(this.row))
                    data.data && JSON.stringify(data.data) != "{}" ? data.data = JSON.parse(data.data) : data.data = []
                    this.oneForm = data
                }
            },
            editOneForm() {
                this.$emit('editForm', this.oneForm)
            },
            delOneForm() {
                this.$confirm(`此操作将删除${this.oneForm.title}, 是否继续?`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    confirmButtonClass: 'el-button--danger',
                    type: 'danger'
                }).then(() => {
                    this.$emit("delForm", { uuid: this.oneForm.uuid })
                }).catch(() => {
                    this.$message.info("取消删除")

                })

            },
            moveAction(action) {
                this.$emit('moveAction', { rank: this.rank - 1, action })
            }
        }
    }
</script>
<style>
    .oneForm:hover {
        background-color: #cccccc;
    }

    .oneForm>.el-form-item {
        margin: 10px;
        cursor: pointer;
    }
</style>